import React from "react";

interface Props {
  label: string;
  value: string;
  highlight?: boolean;
  green?: boolean;
}

export default function KpiCard({ label, value, highlight, green }: Props) {
  return (
    <div
      className={`rounded-xl border p-5 transition-all hover:-translate-y-0.5 hover:shadow-lg ${
        highlight
          ? "bg-gradient-to-br from-blue-500/10 to-purple-500/10 border-blue-500/50"
          : "bg-[#1e2130] border-[#2a2d3e] hover:border-blue-500/50"
      }`}
    >
      <div className="text-xs text-gray-400 uppercase tracking-wider mb-1.5">{label}</div>
      <div className={`text-2xl font-bold tracking-tight ${green ? "text-emerald-400" : ""}`}>
        {value}
      </div>
    </div>
  );
}
